import { userService } from "../services";
import config from "../config/config";

export const ScheduledAction = {
  fetchScheduledMeting,
  filterHrmData,
  FetchshowcompanyBaseHeader,
  configurationdetails,
  fetchReassinedUser,
  fetchScheduledMetingForDasboard,
  importScheduledMeeting,
};

async function fetchScheduledMeting(payload) {
  try {
    let apiEndpoint = `${config.baseUrl}${config.apiName.ScheduledMeting}`;
    const response = await userService.post(apiEndpoint, payload);
    if (response && response.status === 200) {
      return response.data;
    } else {
      return null;
    }
  } catch (error) {
    console.log("error", error);
    return null;
  }
}

async function fetchScheduledMetingForDasboard(payload) {
  try {
    let apiEndpoint = `${config.baseUrl}${config.apiName.ScheduledMetingFordashboard}`;
    const response = await userService.post(apiEndpoint, payload);
    if (response && response.status === 200) {
      return response.data;
    } else {
      return null;
    }
  } catch (error) {
    console.log("error", error);
    return null;
  }
}

async function filterHrmData(payload) {
  try {
    let apiEndpoint = `${config.baseUrl}${config.apiName.hrmsFilterData}`;
    const response = await userService.post(apiEndpoint, payload);
    if (response && response.status === 200) {
      return response.data;
    } else {
      return null;
    }
  } catch (error) {
    console.log("error", error);
    return null;
  }
}

async function FetchshowcompanyBaseHeader(payload) {
  try {
    let apiEndpoint = `${config.baseUrl}${config.apiName.showcompanyBaseHeader}`;
    const response = await userService.get(apiEndpoint, payload);
    if (response && response.status === 200) {
      return response.data;
    } else {
      return null;
    }
  } catch (error) {
    console.log("error", error);
    return null;
  }
}

async function configurationdetails(payload) {
  try {
    let apiEndpoint = payload.siteId
      ? `${config.baseUrl}${config.apiName.configuration_details}/${payload?.hrmsCompanyId}?siteId=${payload.siteId}`
      : `${config.baseUrl}${config.apiName.configuration_details}/${payload?.hrmsCompanyId}`;
    const response = await userService.get(apiEndpoint, payload);
    if (response && response.status === 200) {
      return response.data;
    } else {
      return null;
    }
  } catch (error) {
    console.log("error", error);
    return null;
  }
}

async function fetchReassinedUser(payload) {
  try {
    let apiEndpoint = `${config.baseUrl}${config.apiName.reassignedUser}`;
    const response = await userService.post(apiEndpoint, payload);
    if (response && response.status === 200) {
      return response.data;
    } else {
      return null;
    }
  } catch (error) {
    console.log("error", error);
    return null;
  }
}

async function importScheduledMeeting(payload) {
  try {
    let apiEndpoint = `${config.baseUrl}${config.apiName.importScheduledMeeting}`;
    const response = await userService.post(apiEndpoint, payload);
    if (response && response.status === 200) {
      return response.data;
    } else {
      return null;
    }
  } catch (error) {
    console.log("error", error);
    return null;
  }
}
